import User from "./admin/User";

export default class UserSession {

  constructor(userResponse) {
    if (userResponse) {
      this.username = userResponse["username"];
      this.user = new User(userResponse["user"]);
      this.transactingPartnerId = userResponse["transacting-partner-id"];
      this.transactingChannelId = userResponse["transacting-channel-id"];
      this.registeringPartnerId = userResponse["registering-partner-id"];
      this.registeringChannelId = userResponse["registering-channel-id"];
      this.privileges = userResponse["privileges"];
      this.passwordExpired = userResponse["password-expired"];
    }
  }

  getPrivileges() {
    return this.privileges;
  }

  toJson() {
    return JSON.stringify(this);
  }

  static fromJson = function (json_string) {
    let data = JSON.parse(json_string);
    let user = new UserSession();
    Object.keys(data).forEach(key => {
      user[key] = data[key];
    });
    return user;
  };

  static toJson = function (obj){
    let jsonObj = {};
    jsonObj["organisation-id"] = obj.organisationId;
    jsonObj["username"] = obj.username;
    jsonObj["transacting-partner-id"] = obj.transactingPartnerId;
    jsonObj["transacting-channel-id"] = obj.transactingChannelId;
    jsonObj["registering-partner-id"] = obj.registeringPartnerId;
    jsonObj["registering-channel-id"] = obj.registeringChannelId;
    jsonObj["privileges"] = obj.privilegeId;
    return jsonObj;
  }
};



// WEBPACK FOOTER //
// ./src/domain/UserSession.js